import { connect } from 'react-redux';
import View from './PlanSelectionDropdownView';
import {
  capsuleId,
  plans,
  clientId,
  getSelectedPlan,
} from '../FinancialPlanCapsuleWrapper/FinancialPlanCapsuleWrapperSelector';
import { setCapsuleFpId } from '../FinancialPlanCapsuleWrapper/FinancialPlanCapsuleWrapperActions';

const mapStateToProps = (state, ownProps) => {
  return {
    clientId: clientId(state, ownProps),
    capsuleId: capsuleId(state, ownProps),
    plans: plans(state, ownProps) || [],
    selectedPlan: getSelectedPlan(state, ownProps),
    isDropdownEnabled: ADV.entities.isOptedIn('MultiPlansSelection'),
  };
};

const mapDispatchToProps = dispatch => ({
  onPlanChanged: (clientId, capsuleId) => ({ value }) => {
    dispatch(setCapsuleFpId(capsuleId, value, clientId));
  },
  optionMapper: plan => ({
    label: plan.name,
    value: plan.planId,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
